export default "__VITE_ASSET__jD3D7tpu__"